import { useState } from "react";
import {
  Menu,
  MenuItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import {
  Send,
  Delete,
  Create,
  Description
} from "@mui/icons-material";
import { isIOS } from "react-device-detect";

function WidgetOptionsMenu(props) {
  const open = Boolean(props.anchorEl);
  function exportToCSV() {
    props.handleCSVExport();
    props.handleOptionsMenuClose();
  };

  return (<Menu
         id="widget-options-menu"
         anchorEl={props.anchorEl}
         open={open}
         aria-hidden={!open}
         anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
         transformOrigin={{ vertical: "top", horizontal: "right" }}
         onClose={props.handleOptionsMenuClose}
         transitionDuration={{ enter: 0, exit: 0 }}
       >
         <MenuItem onClick={props.handleWidgetDeleteConfirmDialog}>
           <ListItemIcon>
             <Delete/>
           </ListItemIcon>
           <ListItemText primary="Delete this Widget" />
         </MenuItem>
         <MenuItem onClick={props.editWidgetTitle}>
           <ListItemIcon>
             <Create/>
           </ListItemIcon>
           <ListItemText
             primary={(props.hasTitle ? "Rename" : "Name") + " this Widget"}
                />
         </MenuItem>
         {!isIOS && props.handleCSVExport && (
           <MenuItem onClick={exportToCSV}>
             <ListItemIcon>
               <Description/>
             </ListItemIcon>
             <ListItemText primary="Export to CSV" />
           </MenuItem>
         )}
         {props.setupReport && (             
           <MenuItem onClick={()=>{ props.handleOptionsMenuClose(); props.setupReport() }}>
             <ListItemIcon>
               <Send />
             </ListItemIcon>
             <ListItemText primary="Set up Reporting" />
           </MenuItem>
         )}
         </Menu>)
}

export default WidgetOptionsMenu;
